export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7834.da51eb81.jpg";